import * as React from 'react';

import { DmcaPage } from '@common/components/DmcaPage';
import { withDmcaContainer } from '@common/containers/Dmca';

import { IDmcaProps } from './types';

import * as classNames from './Dmca.scss';

class DmcaContainer extends React.PureComponent<IDmcaProps> {

	render() {
		return (
			<DmcaPage
				{...this.props}
				isMobile={false}
				classNames={classNames}
			/>
		);
	}

}

export const Dmca = withDmcaContainer(DmcaContainer);
